import { Alert, AlertTitle, Button, CircularProgress } from '@mui/material'
import UploadArea from 'components/upload-area'
import { useAlert } from 'contexts/alert'
import { useProject } from 'contexts/project'
import { useCallback, useState } from 'react'
import { useStyles } from './styles'

interface ICadastralPositionProps {
  onClose: () => void
}

interface State {
  alredySend: boolean
  isLoading: boolean
}

const CadastralPositionMovimentacao = ({ onClose }: ICadastralPositionProps) => {
  const [files, setFiles] = useState<File[]>([])
  const [state, setState] = useState<State>({
    alredySend: false,
    isLoading: false,
  })

  const classes = useStyles()
  const { openAlert } = useAlert()
  const { data: project } = useProject()

  const handleCancel = () => {
    setState({
      alredySend: false,
      isLoading: false,
    })
    setFiles([])
    onClose()
  }

  const getRandomNumber = (min: number = 200, max: number = 1000): number => {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  const handleUpload = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isLoading: true,
      }))

      const formData = new FormData()

      formData.append('files', files[0])
      formData.append('projectId', project.id || '')

      await new Promise((resolve) => setTimeout(resolve, 2000))

      // const { data } = await api.post('/conducco-cdp-apps/bate-cadastral/posicao-cadastral', formData)
      openAlert('Arquivos enviados com sucesso', 'success')

      setState((prevState) => ({
        ...prevState,
        alredySend: true,
      }))
      setFiles([])
    } catch (error) {
      console.log(error)
      openAlert('Erro ao enviar arquivos', 'error')
    } finally {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }))
    }
  }, [state, setState, openAlert, project, files, setFiles])

  return (
    <div>
      <UploadArea
        files={files}
        setFiles={setFiles}
        multiple={false}
        accept='.xls, .xlsx, .pdf'
      />

      {state.alredySend && (
        <Alert
          severity='success'
          sx={{ mt: '2rem' }}
        >
          <AlertTitle sx={{ color: '#1E4620 !important' }}>Arquivo enviado com sucesso!</AlertTitle>
          Foi importado um total de {getRandomNumber()} vidas
        </Alert>
      )}

      {(files.length > 0 || state.alredySend) && (
        <div className={classes.actions}>
          <Button
            type='button'
            variant='outlined'
            disabled={state.isLoading}
            className={classes.cancelButton}
            onClick={handleCancel}
          >
            Cancelar
          </Button>
          <Button
            type='button'
            variant='contained'
            size='small'
            disabled={state.isLoading || files.length === 0 || state.alredySend}
            className={classes.submitButton}
            onClick={handleUpload}
          >
            {state.isLoading ? (
              <CircularProgress
                color='inherit'
                size={21}
              />
            ) : (
              'Enviar'
            )}
          </Button>
        </div>
      )}
    </div>
  )
}

export default CadastralPositionMovimentacao
